import Cookie from "js.cookie";

const COOKIE_EXPIRE_DAYS = 1000;

const actions = {
  init: "init",
  setColumnOrder: "setColumnOrder",
  columnDoneResizing: "columnDoneResizing",
  toggleHideColumn: "toggleHideColumn",
};

const pluginName = "useHeaderStatePersist";

const useHeaderStatePersist = hooks => {
  hooks.stateReducers.push(reducer);
};

useHeaderStatePersist.pluginName = pluginName;

// eslint-disable-next-line max-params
function reducer(state, action, previousState, instance) {
  let storage = Cookie;
  // Storage should implement "get" and "set" methods
  if (
    instance.initialState.storage &&
    typeof instance.initialState.storage.get === "function" &&
    typeof instance.initialState.storage.set === "function"
  ) {
    storage = instance.initialState.storage;
  }
  if (action.type === actions.toggleHideColumn) {
    let columnOrder = [...state.columnOrder];

    if (action.value) {
      columnOrder = columnOrder.filter(column => column !== action.columnId);
    } else {
      columnOrder.push(action.columnId);
    }

    storage.set(
      instance.initialState.storageKey + actions.setColumnOrder,
      columnOrder,
      {
        live: COOKIE_EXPIRE_DAYS,
      }
    );
    return {
      ...state,
      columnOrder,
    };
  }

  if (action.type === actions.columnDoneResizing) {
    storage.set(
      instance.initialState.storageKey + actions.columnDoneResizing,
      state.columnResizing.columnWidths,
      {
        live: COOKIE_EXPIRE_DAYS,
      }
    );
    return state;
  }

  if (action.type === actions.setColumnOrder) {
    storage.set(
      instance.initialState.storageKey + actions.setColumnOrder,
      state.columnOrder,
      {
        live: COOKIE_EXPIRE_DAYS,
      }
    );
    return state;
  }

  if (action.type === actions.init) {
    let rehydratedState = {};

    if (state.columnResizing) {
      rehydratedState = {
        ...rehydratedState,
        columnResizing: {
          ...rehydratedState.columnWidths,
          columnWidths:
            storage.get(
              instance.initialState.storageKey + actions.columnDoneResizing
            ) || {},
        },
      };
    }

    if (state.columnOrder) {
      const columnOrder =
        storage.get(
          instance.initialState.storageKey + actions.setColumnOrder
        ) || state.columnOrder;
      rehydratedState = {
        ...rehydratedState,
        columnOrder,
      };
    }

    if (state.columnOrder && state.columnOrder.length) {
      const hiddenColumns = instance.columns.reduce((acc, column) => {
        if (!rehydratedState.columnOrder.includes(column.accessor)) {
          acc.push(column.accessor);
        }
        return acc;
      }, []);

      rehydratedState = {
        ...rehydratedState,
        hiddenColumns,
      };
    }

    return {
      ...state,
      ...rehydratedState,
    };
  }

  return state;
}

export default useHeaderStatePersist;
